import { render, staticRenderFns } from "./imgCodeValidate.vue?vue&type=template&id=63cddf1a"
import script from "./imgCodeValidate.vue?vue&type=script&lang=js"
export * from "./imgCodeValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports